'use strict';

const SI_MODE = {
    0x00: 'UART_FALSE',
    0x01: 'UART_TRUE',
    0x02: 'UART_ABOVE',
    0x03: 'UART_BELOW',
    0x04: 'UART_WITHIN',
};

function parse(reader) {
    reader.readUInt8('data.params.rule_index');
    reader.readUInt8('data.params.chn_index');
    reader.readUInt32LE('data.params.continue_time');
    reader.readUInt32LE('data.params.lockout_time');
    reader.readUInt8('data.params.sign_type', value => SI_MODE[value]);
    reader.readFloatLE('data.params.high');
    reader.readFloatLE('data.params.low');
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_1/common/rule/uart-channel-condition.js